import React, { useCallback, useEffect, useRef, useState } from "react";
import moment from "moment";
import { AiOutlineFileExcel } from "react-icons/ai";
import { createMuiTheme, ThemeProvider, makeStyles } from "@material-ui/core";
import AudioPlayer from "material-ui-audio-player";

const useStyles = makeStyles((theme: any) => {
  return {
    root: {
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    volumeSlider: {
      color: "black",
    },
    progressTime: {
      color: "rgba(0, 0, 0, 0.54)",
    },
    mainSlider: {
      color: "#3f51b5",
      "& .MuiSlider-rail": {
        color: "#7986cb",
      },
      "& .MuiSlider-track": {
        color: "#3f51b5",
      },
      "& .MuiSlider-thumb": {
        color: "#303f9f",
      },
    },
  };
});

const MessageComponent = ({ message }) => {
  const logedinAgent = JSON.parse(localStorage.getItem("tokenAgent"));

  const muiTheme = createMuiTheme({});

  if (message.msg_sent_type === "NOTIFICATIONS") {
    if (message.message === "Customer Ended the Chat") {
      return (
        <div className="times" style={{ background: "#d93d32" }}>
          {message.message}
        </div>
      );
    } else {
      return <div className="times">{message.message}</div>;
    }
  } else if (message.senderName == logedinAgent.username) {
    return (
      <div className="chat-r">
        <div className="user-chat-main d-flex justify-content-end flex-column align-items-end">
          {/* {message.msg_sent_type === "TEXT" ? (
            <div className="user-chats text-break">{message.message}</div>
          ) : null} */}

          {message.msg_sent_type === "TEXT" ||
          message.msg_sent_type == "text" ? (
            <div className="user-chats text-break">
              {message.message.includes("http://") ||
              message.message.includes("www.") ||
              message.message.includes("https://")
                ? message.message.split(" ").map((word, index) => {
                    if (
                      word.includes("http://") ||
                      word.includes("https://") ||
                      word.includes("www.")
                    ) {
                      return (
                        <a
                          href={word}
                          key={index}
                          style={{
                            color: "white",
                            borderBottom: "1px solid grey",
                            textDecoration: "underline",
                          }}
                          target="_blank"
                        >
                          {word}
                        </a>
                      );
                    } else {
                      return word + " ";
                    }
                  })
                : message.message}
            </div>
          ) : null}

          {message.msg_sent_type === "APPLICATION" ? (
            <div className="user-chats-file algin-text">
              <a href={message.message} target="_blank" className="text-white">
                <AiOutlineFileExcel size={20} className="excel-icon" />{" "}
                {message.file_name}
              </a>
            </div>
          ) : null}

          {message.msg_sent_type === "IMAGE" ? (
            <div
              className="card p-2"
              // style={{ borderRadius: "10px 10px 0 10px" }}
            >
              <a href={message.message} target="_blank">
                <img
                  src={message.message}
                  height="130px"
                  width={150}
                  alt="message"
                />
              </a>
            </div>
          ) : null}

          {message.msg_sent_type === "VIDEO" ? (
            <div
              className="card p-2"
              style={{ borderRadius: "10px 10px 0 10px" }}
            >
              <a href={message.message} target="_blank">
                <video width="150" controls>
                  <source src={message.message} type="video/mp4" />
                </video>
              </a>
            </div>
          ) : null}

          {message.msg_sent_type === "AUDIO" ? (
            <div className="user-chats-audio">
              <AudioPlayer src={message.message} useStyles={useStyles} />
            </div>
          ) : null}
        </div>
        <div className="chat-time-r">
          {moment(message.time).format("h:mm A")} -
          <div className="mx-1" style={{ fontSize: "10px" }}>
            {message.senderName}
          </div>
        </div>
      </div>
    );
  } else if (message.senderName !== logedinAgent.username) {
    return (
      <div className="chat-l">
        <div className="bot-chat-main d-flex justify-content-start">
          <div className="d-flex justify-content-start flex-column align-items-start w-100">
            {message.msg_sent_type === "TEXT" ||
            message.msg_sent_type === "text" ? (
              <div className="bot-chats text-break">
                {message.message.includes("http://") ||
                message.message.includes("www.") ||
                message.message.includes("https://")
                  ? message.message.split(" ").map((word, index) => {
                      if (
                        word.includes("http://") ||
                        word.includes("https://") ||
                        word.includes("www.")
                      ) {
                        return (
                          <a
                            href={word}
                            key={index}
                            style={{
                              color: "white",
                              borderBottom: "1px solid grey",
                              textDecoration: "underline",
                            }}
                            target="_blank"
                          >
                            {word}
                          </a>
                        );
                      } else {
                        return word + " ";
                      }
                    })
                  : message.message}
              </div>
            ) : null}
            {message.msg_sent_type === "APPLICATION" ? (
              <div className="user-chats-file text-break">
                <a
                  href={message.message}
                  target="_blank"
                  className="text-white"
                >
                  <AiOutlineFileExcel size={20} className="excel-icon" />{" "}
                  {message.file_name}
                </a>
              </div>
            ) : null}

            {message.msg_sent_type === "IMAGE" ? (
              <div className="card p-2" style={{ height: "150px" }}>
                <a href={message.message} target="_blank">
                  <img
                    src={message.message}
                    height="130px"
                    width={150}
                    alt="message"
                  />
                </a>
              </div>
            ) : null}

            {message.msg_sent_type === "VIDEO" ? (
              <div
                className="card p-2"
                style={{ borderRadius: "10px 10px 10px 0px" }}
              >
                <a href={message.message} target="_blank">
                  <video width="150" controls>
                    <source src={message.message} type="video/mp4" />
                  </video>
                </a>
              </div>
            ) : null}

            {message.msg_sent_type === "AUDIO" ? (
              <div className="user-chats-audio">
                <AudioPlayer src={message.message} useStyles={useStyles} />
              </div>
            ) : null}
          </div>
        </div>
        <div className="chat-time-l">
          {moment(message.time).format("h:mm A")} -
          <div className="mx-1" style={{ fontSize: "10px" }}>
            {message.senderName}
          </div>
        </div>
      </div>
    );
  }
};

export default MessageComponent;
